<script>
	import { onMount } from 'svelte';
import datePicker from 'bulma-calendar/dist/js/bulma-calendar.min';
import { t, languageStore } from "totalinvoice-frontend-core"

export let onchange = null
export let id;
export let placeholder

let language = $languageStore.selected

let options = {
  lang: language,
  dateFormat: "YYYYMMDD",
  showHeader: false,
  showFooter: false,
  toggleOnInputClick: true
}
// Initialize all input of date type.
let calendars ;

let calendar

function initCalendar(){
    calendars = datePicker.attach('#'+id, options);
    calendar = document.querySelector('#'+id);
    if (calendar) {
      calendar.bulmaCalendar.on('select', function(datepicker) {
        onchange(datepicker.data.value());
      });
    }
}

onMount( () => {
    initCalendar()
});


$: {
    language = $languageStore.selected;
    if (calendar) {
        calendar.bulmaCalendar.lang = language
        calendar.bulmaCalendar.datePicker.refresh()
    }
  }

</script>
<style>

</style>
<input id={id} placeholder={placeholder} class="customDatepicker" type="date" />